import { Action } from "@ngrx/store";
import { SurveyActionTypes } from ".";
import { Survey, SurveyAnswerData, SurveyDemographicAnswerData } from "../../model/SurveyModel";


export class SurveyClearAction implements Action {
    public type = SurveyActionTypes.SURVEY_CLEAR;
    public surveyData: Survey;
    public answerData: Array<SurveyAnswerData>;
    public answerDemographicData: Array<SurveyDemographicAnswerData>;
    public teamSurveys: Array<Survey>;
    public organizationSurveys: Array<Survey>;
    public errorPayload: any;
    constructor() { }
}

export class SurveyLoadDemographicAnswerAction implements Action {
    public type = SurveyActionTypes.SURVEY_LOAD_DEMOGRAPHIC_ANSWER;
    public surveyData: Survey;
    public answerData: Array<SurveyAnswerData>;
    public answerDemographicData: Array<SurveyDemographicAnswerData>;
    public teamSurveys: Array<Survey>;
    public organizationSurveys: Array<Survey>;
    public errorPayload: any;
    constructor(public payload: { demograficoId: number, userId: number }) { }
}

export class SurveyLoadAnswerAction implements Action {
    public type = SurveyActionTypes.SURVEY_LOAD_ANSWER;
    public surveyData: Survey;
    public answerData: Array<SurveyAnswerData>;
    public answerDemographicData: Array<SurveyDemographicAnswerData>;
    public teamSurveys: Array<Survey>;
    public organizationSurveys: Array<Survey>;
    public errorPayload: any;
    constructor(public payload: { userId: number, applySurveyId: number }) { }
}

export class SurveySaveAnswerAction implements Action {
    public type = SurveyActionTypes.SURVEY_SAVE_ANSWER;
    public surveyData: Survey;
    public answerData: Array<SurveyAnswerData>;
    public answerDemographicData: Array<SurveyDemographicAnswerData>;
    public teamSurveys: Array<Survey>;
    public organizationSurveys: Array<Survey>;
    public errorPayload: any;
    constructor(public payload: { answerInfo: SurveyAnswerData, type: string }) { }
}

export class SurveySaveDemographicAnswerAction implements Action {
    public type = SurveyActionTypes.SURVEY_SAVE_DEMOGRAPHIC_ANSWER;
    public surveyData: Survey;
    public answerData: Array<SurveyAnswerData>;
    public answerDemographicData: Array<SurveyDemographicAnswerData>;
    public teamSurveys: Array<Survey>;
    public organizationSurveys: Array<Survey>;
    public errorPayload: any;
    constructor(public payload: { answerInfo: SurveyDemographicAnswerData, type: string }) { }
}

export class SurveyClearErrorsAction implements Action {
    public type = SurveyActionTypes.SURVEY_CLEAR_ERRORS;
    public surveyData: Survey;
    public answerData: Array<SurveyAnswerData>;
    public answerDemographicData: Array<SurveyDemographicAnswerData>;
    public teamSurveys: Array<Survey>;
    public organizationSurveys: Array<Survey>;
    public errorPayload: any;
    constructor() { }
}

export type SurveyActions = SurveyClearAction | SurveyLoadAnswerAction | SurveySaveAnswerAction | SurveySaveDemographicAnswerAction | SurveyClearErrorsAction;


// WEBPACK FOOTER //
// ./src/store/action/SurveyActions.ts